export default {
  p: { x: 272, y: 255 },
  r: 30,
  s: [{ x: 464, y: 350, b: 'ew', d: 100 }],
  b: [{ x: 260, y: 220 }],
  g: [
    { x: 400, y: 600 },
    { x: 600, y: 50 },
  ],
  h: [
    { x: 260, y: 50 },
    { x: 580, y: 100 },
  ],
};
